import React, { Dispatch, SetStateAction } from 'react'
import AsideFilterComponent from './AsideFilterComponent'
import { Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import MobileSheet from '@/components/ui/MobileSheet'
import { cn } from '@/utilities/ui'

interface PropsType {
  className: string
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>

  search: any
  handleSearchChange: any
  listedIn: any
  selectedCategories: any
  toggleCategory: any
  onListedInChange: any
  minPrice: any
  onMinPriceChange: any
  maxPrice: any
  onMaxPriceChange: any
  minSurface: any
  onMinSurfaceChange: any
  maxSurface: any
  onMaxSurfaceChange: any
  rooms: any
  onRoomsChange: any
  amenities: any
  toggleAmenity: any
  updateSearchParams: any
  onReset: any
  willayaList: any
  setSelectedWillayas: any
  selectedWillayas: any
  isWillayaPopoverOpen: any
  setIsWillayaPopoverOpen: any
  citiesList: any
  setSelectedCities: any
  selectedCities: any
  isCityPopoverOpen: any
  setIsCityPopoverOpen: any
  isOpenOtherFeatures: any
  setIsOpenOtherFeatures: any
  showAdvancedSearch: any
  setShowAdvancedSearch: any
  PropertyCategories: any
  roomOptions: any
  FeatureSearchList: any
  dictionary: any
  lang: any
}

const MobilePropertyListingFilterComponent = ({
  className,
  open,
  setOpen,

  search,
  handleSearchChange,
  listedIn,
  selectedCategories,
  toggleCategory,
  onListedInChange,
  minPrice,
  onMinPriceChange,
  maxPrice,
  onMaxPriceChange,
  minSurface,
  onMinSurfaceChange,
  maxSurface,
  onMaxSurfaceChange,
  rooms,
  onRoomsChange,
  amenities,
  toggleAmenity,
  updateSearchParams,
  onReset,
  willayaList,
  setSelectedWillayas,
  selectedWillayas,
  isWillayaPopoverOpen,
  setIsWillayaPopoverOpen,
  citiesList,
  setSelectedCities,
  selectedCities,
  isCityPopoverOpen,
  setIsCityPopoverOpen,
  isOpenOtherFeatures,
  setIsOpenOtherFeatures,
  showAdvancedSearch,
  setShowAdvancedSearch,
  PropertyCategories,
  roomOptions,
  FeatureSearchList,
  dictionary,
  lang,
}: PropsType) => {
  // Check if RTL
  const isRTL = lang === 'ar'

  return (
    <MobileSheet
      header={
        <div className="!h-[80px] flex flex-row items-center justify-start relative">
          <p className={cn('text-typography text-sm px-6', isRTL && 'text-right')}>
            {dictionary?.propertyListing?.filter || 'Filter'}
          </p>
          <div
            onClick={() => setOpen(false)}
            className={cn(
              'cursor-pointer absolute !m-0 top-1/2 -translate-y-1/2',
              isRTL ? 'left-4' : 'right-4',
            )}
          >
            <X className="w-5 h-5 text-typography" />
          </div>
        </div>
      }
      footer={
        <div className="bg-white h-[80px] !p-0 !m-0">
          {/* Action Buttons */}
          <div
            className={cn(
              'h-full w-full flex px-6 text-black items-center justify-between',
              isRTL && 'flex-row-reverse',
            )}
          >
            <Button
              variant="link"
              onClick={onReset}
              className={cn(
                'flex items-center text-black hover:text-primary transition-colors duration-200',
                isRTL && 'flex-row-reverse',
              )}
            >
              <img
                src="/icons/back.svg"
                alt="back svg"
                className={cn(isRTL ? 'ml-2 scale-x-[-1]' : 'mr-2')}
              />
              {dictionary?.propertyListing?.asideFilter?.resetAllFilters || 'Reset all filters'}
            </Button>
            <Button
              className={cn(
                'px-6 h-[55px] bg-primary-300 hover:bg-primary-400 text-white flex items-center',
                isRTL && 'flex-row-reverse',
              )}
              onClick={updateSearchParams}
            >
              <Search size={16} className={cn(isRTL ? 'ml-2' : 'mr-2')} />
              {dictionary?.propertyListing?.asideFilter?.search || 'Search'}
            </Button>
          </div>
        </div>
      }
      open={open}
    >
      <AsideFilterComponent
        className={className}
        search={search}
        handleSearchChange={handleSearchChange}
        selectedCategories={selectedCategories}
        toggleCategory={toggleCategory}
        listedIn={listedIn}
        onListedInChange={onListedInChange}
        minPrice={minPrice}
        onMinPriceChange={onMinPriceChange}
        maxPrice={maxPrice}
        onMaxPriceChange={onMaxPriceChange}
        minSurface={minSurface}
        onMinSurfaceChange={onMinSurfaceChange}
        maxSurface={maxSurface}
        onMaxSurfaceChange={onMaxSurfaceChange}
        rooms={rooms}
        onRoomsChange={onRoomsChange}
        amenities={amenities}
        toggleAmenity={toggleAmenity}
        updateSearchParams={updateSearchParams}
        onReset={onReset}
        willayaList={willayaList}
        setSelectedWillayas={setSelectedWillayas}
        selectedWillayas={selectedWillayas}
        isWillayaPopoverOpen={isWillayaPopoverOpen}
        setIsWillayaPopoverOpen={setIsWillayaPopoverOpen}
        citiesList={citiesList}
        setSelectedCities={setSelectedCities}
        selectedCities={selectedCities}
        isCityPopoverOpen={isCityPopoverOpen}
        setIsCityPopoverOpen={setIsCityPopoverOpen}
        isOpenOtherFeatures={isOpenOtherFeatures}
        setIsOpenOtherFeatures={setIsOpenOtherFeatures}
        showAdvancedSearch={showAdvancedSearch}
        setShowAdvancedSearch={setShowAdvancedSearch}
        PropertyCategories={PropertyCategories}
        roomOptions={roomOptions}
        FeatureSearchList={FeatureSearchList}
        dictionary={dictionary}
        lang={lang}
      />
    </MobileSheet>
  )
}

export default MobilePropertyListingFilterComponent
